// extracted by css-extract-rspack-plugin
export default {"messageHeader":"messageHeader-s76IKy","creatorInfo":"creatorInfo-o_T1tF","date":"date-b1leRg","internalNoteLabel":"internalNoteLabel-PsYIiO"};